export default __webpack_public_path__ + "static/media/header-dots.bdd15e3a.png";